import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getLeadsAction } from "./actions";
import { updateLead } from "./services";

import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  Dialog,
  DialogContent,
  DialogActions,
  DialogTitle,
  Typography,
  TextField
} from "@mui/material";

import { createTheme, ThemeProvider } from "@mui/material/styles";

const customTheme = createTheme({
  // Add styles specific to the Leads.js file
  tableContainer: {},
  tableHead: {
    background: "#0089C4",
  },
  tableHeadCell: {
    fontWeight: "bold",
    color: "#ffffff",
    background: "#0089C4",
    fontSize: 12,
  },
  tableRow: {
    "&:hover": {},
  },
});

const Leads = () => {
  const dispatch = useDispatch();
  const { loading, leads, error } = useSelector((state) => state.lead);

  const [action, setAction] = useState("");
  const [leadId, setLeadId] = useState("");
  const [dialogOpen, setDialogOpen] = useState(false);

  useEffect(() => {
    // Check if leads are not fetched yet
    if (leads.length === 0) {
      dispatch(getLeadsAction());
    }
  }, []);

  const handleOpenDialog = (id) => {
    setLeadId(id);
    setDialogOpen(true);
  };

  const handleCloseDialog = () => {
    updateLead({
      name: "name",
      id: leadId,
      actionTaken: action,
    })
      .then((res) => {
        console.log(res);
        dispatch(getLeadsAction());
      })
      .catch((err) => {
        console.log(err);
      });
    setDialogOpen(false);
  };

  return (
    <ThemeProvider theme={customTheme}>
        <TableContainer component={Paper} className={customTheme.tableContainer}>
          <Table aria-label="leads table">
            <TableHead className={customTheme.tableHead}>
              <TableRow>
                <TableCell className={customTheme.tableHeadCell}>Lead Name</TableCell>
                <TableCell className={customTheme.tableHeadCell} align="left">
                  Purpose
                </TableCell>
                <TableCell className={customTheme.tableHeadCell} align="left">
                  Message
                </TableCell>
                <TableCell className={customTheme.tableHeadCell} align="left">
                  Action Taken
                </TableCell>
                <TableCell className={customTheme.tableHeadCell} align="left">
                  Employee
                </TableCell>
                <TableCell className={customTheme.tableHeadCell} align="right"></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {leads?.map((lead) => (
                <TableRow
                  key={lead.id}
                  className={customTheme.tableRow}
                  sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                >
                  <TableCell component="th" scope="row">
                    {lead.name}
                    <br />
                    <span style={{ fontSize: "0.8rem", color: "#888" }}>
                      {lead.date} {lead.time}
                    </span>
                  </TableCell>
                  <TableCell align="left">{lead.purpose}</TableCell>
                  <TableCell align="left">{lead.message}</TableCell>
                  <TableCell align="left">{lead.actionTaken}</TableCell>
                  <TableCell align="left">{lead.Employee?.name}</TableCell>
                  <TableCell align="right">
                    <Button variant="contained" onClick={() => handleOpenDialog(lead.id)}>
                      Action
                    </Button>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>

        {/* Dialog Box */}
        <Dialog sx={{ left: "10%" }} maxWidth="md" open={dialogOpen} onClose={handleCloseDialog}>
          <DialogTitle>What action did you take?</DialogTitle>
          <DialogContent>
            {/* Content inside the dialog */}
            <Typography variant="body1"></Typography>
            <TextField name="action" label="Action" onChange={(e) => setAction(e.target.value)} />
          </DialogContent>
          <DialogActions>
            {/* Action buttons inside the dialog */}
            <Button size="small" onClick={() => setDialogOpen(false)} color="primary">
              Cancel
            </Button>
            <Button size="small" onClick={handleCloseDialog} color="primary" variant="contained">
              Update
            </Button>
          </DialogActions>
        </Dialog>
    </ThemeProvider>
  );
};

export default Leads;
